import { gql } from '@apollo/client';

export const BULK_UPDATE_ROLE_STATUS = gql`
  mutation bulkUpdateRoleStatus($userTypeIds: [Int]!, $status: EUserTypeStatus!) {
    userType {
      bulkUpdateStatus(userTypeIds: $userTypeIds, status: $status)
    }
  }
`;
